export default function formatElapsedTime(submittedAt, endAt) {
  if (!submittedAt) return null;

  const start = new Date(submittedAt);
  const end = endAt ? new Date(endAt) : new Date();

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return null;

  const totalSeconds = Math.max(Math.floor((end.getTime() - start.getTime()) / 1000), 0);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) return `${hours}h ${minutes}m`;
  if (minutes > 0) return `${minutes}m ${seconds}s`;

  return `${seconds}s`;
}
